/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Injectable } from '@angular/core';
import { IApplicationLog } from 'generated-types';

/**
 * @description
 *     Service for calculating vs log duration metrics.
 * @author Shanmukha Sarath Kondiparthi
 */
@Injectable()
export class VsLogsDurationDetailService {
    public largestTotalTimeDuration: number;

    private vsLogsGridRows: IApplicationLog[];

    public getLargestTotalTime(vsLogs: IApplicationLog[]): number {
        const isVsLogsGridRowsChanged = this.vsLogsGridRows !== vsLogs;

        if (isVsLogsGridRowsChanged) {
            this.vsLogsGridRows = vsLogs;
            this.calculateLargestTotalTime();
        }

        return this.largestTotalTimeDuration;
    }

    public getWafTime({ waf_log: wafLog = {} }: IApplicationLog): number {
        const wafSum: number = [
            'latency_request_header_phase',
            'latency_request_body_phase',
            'latency_response_header_phase',
            'latency_response_body_phase',
        ].reduce((sumSoFar: number, field: string): number => {
            return sumSoFar += Number(wafLog[field]) || 0;
        }, 0);

        // milliseconds to seconds.
        const wafTime = Math.round(wafSum / 1000);

        return wafTime;
    }

    private calculateLargestTotalTime(): void {
        this.largestTotalTimeDuration = this.vsLogsGridRows.reduce(
            (maxTimeSoFar: number, row: IApplicationLog): number => {
                const vsLogsResponseTime = [
                    'client_rtt',
                    'server_rtt',
                    'app_response_time',
                    'data_transfer_time',
                ].reduce((sumSoFar, field) => {
                    return sumSoFar += Number(row[field]) || 0;
                }, 0);

                const wafTime = Number(this.getWafTime(row)) || 0;
                const totalTime = vsLogsResponseTime + wafTime;

                return Math.max(totalTime, maxTimeSoFar);
            }, 0,
        );
    }
}
